import React from 'react'
import { connect } from 'react-redux'
import { CHANGE_TO_FREE_STYLE_MODAL } from '@chegg-wt/core/state/modals/constants'
import { CancelIcon } from '@chegg-ui/theme'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { styleSelected } from '@chegg-wt/core/state/currentProject/actions'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { getUrlStyle } from '@chegg-wt/core/server/utils/redirect'
import {
  currentProjectIdSelector,
  styleGateFlagSelector,
} from '@chegg-wt/core/state/currentProject/selectors'
import { getCapitalizedSEONameOfStyle } from '@chegg-wt/core/utils/styles'
import { ModalWrapper, DefaultBackdrop, PositioningWrapper } from '../styled'
import {
  BACKDROP,
  MODAL_CONTENT,
  CLOSE_BUTTON,
  TITLE_TEXT,
  CONTINUE_BUTTON,
} from './testIds'
import { ChangeToFreeStyleModalProps } from './types'
import * as Styled from './styled'
import { CONTINUE, MAX_WIDTH } from './constants'

const getModalTitle = (freeStyle: string) =>
  `Changing the citation list style to ${getCapitalizedSEONameOfStyle(
    getUrlStyle(freeStyle)
  )}. To change the style back to any other style later, you will need to start free trial.`

export const ChangeToFreeStyleModal: React.FC<ChangeToFreeStyleModalProps> = ({
  closeModal,
  modalData,
  isStyleGateFlagEnabled,
  styleSelected,
  navigated,
  currentProjectId,
}) => {
  const { toBibliography } = useRoutesContext()

  const handleCloseModal = () => {
    closeModal(CHANGE_TO_FREE_STYLE_MODAL)
  }

  const handleContinue = () => {
    modalData.callbackFn() // create citation
    styleSelected(modalData.changeToStyle, false, true, isStyleGateFlagEnabled)
    if (modalData.redirect) {
      navigated(
        toBibliography({ style: modalData.changeToStyle, projectId: currentProjectId })
      )
    }
    handleCloseModal()
  }
  return (
    <ModalWrapper
      backdrop
      show
      renderBackdrop={() => <DefaultBackdrop data-test={BACKDROP} />}
    >
      <PositioningWrapper>
        <Styled.ModalContent
          fullMobileModal={false}
          maxWidth={MAX_WIDTH}
          data-test={MODAL_CONTENT}
        >
          <Styled.CloseButton
            screenReaderOnlyText="close modal"
            onClick={handleCloseModal}
            data-test={CLOSE_BUTTON}
          >
            <CancelIcon />
          </Styled.CloseButton>
          <Styled.ContentContainer>
            <Styled.TitleText data-test={TITLE_TEXT}>
              {getModalTitle(modalData.changeToStyle)}
            </Styled.TitleText>
            <Styled.ContinueButton onClick={handleContinue} data-test={CONTINUE_BUTTON}>
              {CONTINUE}
            </Styled.ContinueButton>
          </Styled.ContentContainer>
        </Styled.ModalContent>
      </PositioningWrapper>
    </ModalWrapper>
  )
}

const mapStateToProps = (state) => ({
  modalData: modalDataSelector(state),
  isStyleGateFlagEnabled: styleGateFlagSelector(state),
  currentProjectId: currentProjectIdSelector(state),
})

const mapDispatchToProps = {
  closeModal,
  styleSelected,
  navigated,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeToFreeStyleModal)
